export const Keys = Object.freeze({
  Enter: "Enter",
  Escape: "Escape",
});
